import dashboardMyFeedsReducer from './reducers';

export { default as dashboardMyFeedsActions } from './actions';
export { default as dashboardMyFeedsSelectors } from './selectors';

export default dashboardMyFeedsReducer;
